// extracted by mini-css-extract-plugin
module.exports = {"root":"Collezione_root__1RD1A","h1":"Collezione_h1__242H1","iframeWrap":"Collezione_iframeWrap__kSlkQ","iframe":"Collezione_iframe__37AnM"};